import axios from "axios";
import { showError } from "../../app/toastify";

import types from "../common/action-types";
import { isSessionExpired } from "../common/actions";

export const getTableMetadata = (cb) => {
  return async (dispatch) => {
    try {
      cb(true, []);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(`/api/reporting/tables`);
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, []);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getFieldMetadata = (table, cb) => {
  return async (dispatch) => {
    try {
      cb(true, []);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(`/api/reporting/fields?table=${table}`);
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, []);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getJoinsMetadata = (table, cb) => {
  return async (dispatch) => {
    try {
      cb(true, []);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(`/api/reporting/joins?table=${table}`);
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, []);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getQueryPreview = (query, cb) => {
  return async (dispatch) => {
    try {
      cb(true, []);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(`/api/reporting/preview`, query);
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, []);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const downloadExcelReport = (query, cb) => {
  return async (dispatch) => {
    try {
      cb(true);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(`/api/reporting/download`, query, {
        responseType: "blob",
      });

      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      link.href = url;
      link.setAttribute("download", `Report_${timestamp}.xlsx`);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      cb(false);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getRetirementProjection = (query, cb) => {
  return async (dispatch) => {
    try {
      cb(true, null);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(
        "/api/reporting/retirement-projection?" +
          new URLSearchParams(query).toString()
      );
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, null);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getRBMYearlyTrending = (query, cb) => {
  return async (dispatch) => {
    try {
      cb(true, null);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(
        "/api/reporting/rbm-yearly-trending?" +
          new URLSearchParams(query).toString()
      );
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, null);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getAdvertisedPostsAndHiresTrending = (query, cb) => {
  return async (dispatch) => {
    try {
      cb(true, null);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(
        "/api/reporting/advertised-posts-hires-trending?" +
          new URLSearchParams(query).toString()
      );
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, null);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getLeavePlanTrend = (query, cb) => {
  return async (dispatch) => {
    try {
      cb(true, null);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(
        "/api/reporting/leave-plan-trending?" +
          new URLSearchParams(query).toString()
      );
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, null);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getTrainingRequestTrend = (query, cb) => {
  return async (dispatch) => {
    try {
      cb(true, null);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(
        "/api/reporting/training-request-trending?" +
          new URLSearchParams(query).toString()
      );
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, null);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getPayrollExpenditureTrend = (query, cb) => {
  return async (dispatch) => {
    try {
      cb(true, null);
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(
        "/api/reporting/payroll-expenditure-trending?" +
          new URLSearchParams(query).toString()
      );
      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, null);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const generateReport = (filters, cb) => {
  return async (dispatch) => {
    try {
      cb(true, null);
      dispatch({ type: types.START_LOADING });

      const query = new URLSearchParams(filters).toString();
      const response = await axios.get(
        "/api/reporting/generate-report?" + query,
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const dateStr = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
      link.download = `${filters.reportTitle}-${
        filters.reportType || ""
      }-${dateStr}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      cb(false, "success");
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, null);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};
